module.exports = __webpack_public_path__ + "static/media/step2img2.d6bde619.PNG";